import { API } from '@config';
import { WorkSignsTable } from '@src/types/WorkSigns';

export const getWorkSigns = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/business-fn-p-work-signs?populate=File&sort=id%3Adesc`, options);
  const data: WorkSignsTable = await response.json();

  return data;
};
